import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const acceptMemberTerms = info =>
  call(websocketFetch, 'accept_member_terms', info);
